export default __webpack_public_path__ + "5c9fc121a8fb49c5888b5bc8246a845a.svg";